<template>
    <div id="listRate">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> {{pageTitle}}</div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="btn-groups text-right">
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                            <i class="fp-export"></i> Export
                        </a>
                        <!-- <router-link v-if="canAdd && hideButton === false" class="btn btn-primary" v-bind:to="{name: 'CustomerScopeRateCreate'}" >
                            <i class="fp-add"> </i> Add
                        </router-link> -->
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content customer-scope-rate">
                        <data-table-filter-config :moduleName="'scopeRateList'" ref="filterScopeRate" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="data-table bg-white">
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange" :moduleName="'scopeRateList'" :position="'top'">
                                  </custom-pagination>

                                  <vue-good-table
                                      mode="remote"
                                      ref="scopRateListTable"
                                      @on-page-change="onPageChange"
                                      @on-sort-change="onSortChange"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      :totalRows="totalRecords"
                                      title="Customer Scope Rate"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :paginate="true"

                                      :paginationOptions="{
                                          enabled: false,
                                          position: 'both',
                                          perPage: perPage,
                                          perPageDropdown:dropDownPerPage,
                                          dropdownAllowAll: false,
                                      }"
                                      :search-options="{
                                      enabled: false,
                                      }"
                                      :sort-options="{
                                      enabled: true,
                                      }"
                                  >
                                  <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                      <div :key="key">
                                          <div v-if="props.column.field == 'action'">
                                              <!-- <template v-if="canUpdate">
                                                  <router-link class="fp-edit" v-bind:to="{name: 'CustomerScopeRateEdit',params:{id:props.row.id}}" title="Edit Customer Scope Rate"/>
                                              </template> -->
                                          </div>
                                          <div v-else>
                                              {{props.formattedRow[props.column.field]}}
                                          </div>
                                      </div>
                                  </template>
                                  </vue-good-table>
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>

<script>

import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
    export default {
        name: "listRate",
        metaInfo() {
            return {
                title: "Customer Scope Rate List | " +process.env.COPYRIGHT_NAME
            }
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
        pageTitle:"Discount Rates",
        hideButton:false,
        firstLoad:0,
        userColumns:[],
        columns: [
            {
                label: 'Actions',
                field: 'action',
                sortable: false,
            },
            {
                label: '#Agreement',
                field: 'agreement_no',
                hidden:false,
                fpFieldType:"text",
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Agreement", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },

            {
                label: 'Customer Name',
                field: 'contact',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Customer Name", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },

            {
                label: 'Asset Type',
                field: 'truck_type',
                fpFieldType:"option",
                hidden:false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Truck Type", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Section',
                field: 'section',
                hidden:false,
                fpFieldType:"option",
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Section", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Rate Column',
                field: 'type',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Rate Column", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Customer Rate',
                field: 'rate',
                fpFieldType:"integer",
                type: 'number',
                hidden:false,
                filterable: true,
                html: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Customer Rate", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },

            // {
            //     label: 'Effective Date',
            //     field: 'effective_date',
            //
            //     filterOptions: {
            //         enabled: true, // enable filter for this column
            //         placeholder: "", // placeholder for filter input
            //         filterValue: '', // initial populated value for this filter
            //         filterDropdownItems: [], // dropdown (with selected values) instead of text input
            //         filterFn: this.onColumnFilter, //custom filter function that
            //         trigger: "enter" //only trigger on enter not on keyup
            //     }
            // },
            // {
            //     label: 'Expiry Date',
            //     field: 'expiry_date',
            //
            //     filterOptions: {
            //         enabled: true, // enable filter for this column
            //         placeholder: "", // placeholder for filter input
            //         filterValue: '', // initial populated value for this filter
            //         filterDropdownItems: [], // dropdown (with selected values) instead of text input
            //         filterFn: this.onColumnFilter, //custom filter function that
            //         trigger: "enter" //only trigger on enter not on keyup
            //     }
            // },
        ],
        rows: [],
        totalRecords: 0,
        permissions:[],
        cantAccessPage: "",
        loading:false,
        canAdd:false,
        canUpdate:false,
        pageKey:"_customer_scope_rate_list_",
        action:'list',
        batchProcess:0,
        batchNum:"",
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'list_rate') {
                    self.cantAccessPage = true;
                }
                if(permissions.name == 'add_rate') {
                    self.canAdd = true;
                    self.canUpdate = true;
                }
            });
            if(self.cantAccessPage == ''){
                self.cantAccessPage = false;
            }
        }
    },
    mounted: function () {

        var self = this;
        if(self.$route.query.flag == 'customerScopeReport'){
              self.hideButton = true;
              self.pageTitle = "Customer Rental Scope Rates";
              for (let index = 0; index < this.columns.length; index++) {

                  if(this.columns[index].field == 'action'){
                      this.$set(this.columns[index], 'hidden', true);
                  }
              }
            }
        
        self.getPermissions();

    },
    methods: {
        cancelAll: function (cancelAll) {
              this.$refs.scopRateListTable.unselectAllInternal();
            },
        // exportReports: function() {
        //     var self = this;
        //     this.action = "export";
        //     this.loadList();
        // },
        //edit rental page
        editRentalRage(params) {

            var self = this;

            if(self.canUpdate == true){
                self.$router.push("/scoperate/edit/" + params.row.id);
            }else{
                self.$swal('',"You Do Not Have Permission To Update Rates",'info');
            }

        },

        /*onColumnFilter(params) {
            this.updateParams(params);
            {field: ('contact');field: ('truck_type'); field: ('section');
                field: ('rate'); field: ('effective_date');
                field: ('expiry_date')}
            this.serverParams.page = 1 ;
            var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
            var filters = filtersPr.columnFilters;

            if (this.firstLoad == 1 || filters.contact || filters.truck_type || filters.section || filters.rate
                || filters.effective_date || filters.expiry_date) {

                this.loadList();
            }


        },
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
            console.log(this.serverParams.columnFilters.company);
        },
        onPageChange(params) {
            this.updateParams({page: params.currentPage});

            this.loadList();
        },
        onSortChange(params) {
            this.updateParams({
                sort: {
                    type: params[0].type,
                    field: params[0].field,
                },

            });
            this.loadList();
        },
        //
        onPerPageChange(params) {
            this.updateParams({perPage: params.currentPerPage});
            this.serverParams.page = 1 ;
            this.totalRecords = self.totalRecords;
            this.loadList();
        },*/
        loadList: function(){
            var self = this;
            self.loading = true;
            var filterAll = self.serverParams.columnFilters;
            if ( self.action == "export" ) {
                filterAll = self.removeOptionArr(self.serverParams.columnFilters);
            }
            self.firstLoad =1;
            var fields = {
                page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: filterAll,
                    sort: self.serverParams.sort,
                    action:self.action
            };
            $.ajax({
                url: process.env.ROOT_API + "/scoperate/list",
                type: "POST",
                data:fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    //console.log(data.content[0]["id"]);
                    // if (data.status == "success") {
                    if ( self.action == "export" ||  self.action == "export_queue") {
                        if ( data.code == "201" ) {
                            alert(data.message);
                        } else {
                            if ( self.action == "export" ) {
                                self.excel = data.content.web;
                                var save = document.createElement("a");
                                save.href = self.excel;
                                save.download = data.content.web;
                                save.target = "_blank";

                                document.body.appendChild(save);
                                save.click();
                                document.body.removeChild(save);

                            } else {

                                self.batchProcess = 1;
                                self.batchNum = data.content;
                            }
                        }
                        self.action = "list";
                        self.loadList();
                    }else{
                        self.rows = data.content.row;
                        self.totalRecords = data.content.totalRecords;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'load-scope-rate-list')
                }
            });
        },
        syncCustomerScopeRate() {

            var self = this;
            self.loading = true;
            $("#syncScopeBtn").text("Syncing...");
            $("#syncScopeBtn").prop("disabled", true);

            $.ajax({
                url: process.env.ROOT_API + "/sync-customerscoperate",
                type: "GET",
                headers: this.ajxHeaders,
                dataType: 'json',
                success: function (data) {

                    self.loading = false;
                    $("#syncScopeBtn").text("Sync");
                    $("#syncScopeBtn").prop("disabled", false);

                    if (data.status == 'success') {

                        self.$swal({
                            // title: data.content + " " ,
                            text: data.content + " Scope Rate are Sync.",
                            type: "success",
                            confirmButtonText: "Confirm",
                        }).then(result => {
                            if (result.value) {
                                    self.loadList();
                                }
                            });
                    }
                },
                error: function (jqXHR, exception) {

                    self.loading = false;
                    $("#syncScopeBtn").text("Sync");
                    $("#syncScopeBtn").prop("disabled", false);

                    self.generateStatusCodeMessage(jqXHR,false,'sync-scope-rate')
                }
            });

        }

        // addrate: function(){
        //     var self = this;
        //
        //     self.$router.push("/addrate");
        // }
    }
    };
</script>




// WEBPACK FOOTER //
// src/components/customer/CustomerScopeRateList.vue